import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMerchDetails } from "../Redux/Actions/merchActions";
import Loading from "../components/LoadingError/Loading";
import Message from "../components/LoadingError/Error";
import Header from "../components/Header";
import { useParams, useHistory } from "react-router-dom";

const SingleMerch = () => {
  const [quantity, setQuantity] = useState(1);
  const [selectedSize, setSelectedSize] = useState("");
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const merchDetails = useSelector((state) => state.merchDetails);
  const { loading, error, merch } = merchDetails;

  useEffect(() => {
    dispatch(getMerchDetails(id));
  }, [dispatch, id]);

  useEffect(() => {
    // Set default size if sizes are available
    if (merch && merch.sizes && merch.sizes.length > 0) {
      setSelectedSize(merch.sizes.split(",")[0].trim());
    }
  }, [merch]);

  const handleQuantityChange = (e) => {
    setQuantity(parseInt(e.target.value));
  };

  const handleSizeChange = (e) => {
    setSelectedSize(e.target.value);
  };

  const handleBuyNow = () => {
    if (!merch) return;
    
    const phoneNumber = "254746003525";
    
   
    const messageText = `Hello! I'm interested in purchasing: 
${merch.name}
Price: ${merch.currency || "Ksh"}${merch.price}
Quantity: ${quantity}
${selectedSize ? `Size: ${selectedSize}` : ""}`;
    
    
    const encodedMessage = encodeURIComponent(messageText);
    
    
    const isMobile = window.innerWidth <= 768;
    
   
    const mobileWhatsAppUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    const webWhatsAppUrl = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;
    
    window.open(isMobile ? mobileWhatsAppUrl : webWhatsAppUrl, "_blank");
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <>
      <Header isHomePage={false} />
      <div className="page-title-container">
      <div className="single-merch-container">
        {loading ? (
          <Loading />
        ) : error ? (
          <Message variant="danger">{error}</Message>
        ) : (
          merch && (
            <div className="single-merch-content">
              <div className="single-merch-image-container">
                <img
                  src={merch.image}
                  alt={merch.name}
                  className="single-merch-image"
                />
              </div>
              <div className="single-merch-details">
                <h1 className="single-merch-title">{merch.name}</h1>
                <h2 className="single-merch-price">
                  {merch.currency || "Ksh "}{merch.price}
                </h2>
                
                {merch.sizes && (
                  <div className="single-merch-sizes">
                    <p>All sizes are available ({merch.sizes})</p>
                    <select 
                      className="single-merch-select"
                      value={selectedSize}
                      onChange={handleSizeChange}
                    >
                      {merch.sizes.split(",").map((size, index) => (
                        <option key={index} value={size.trim()}>
                          {size.trim()}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                
                <div className="single-merch-quantity">
                  <p>Quantity:</p>
                  <select 
                    className="single-merch-select"
                    value={quantity}
                    onChange={handleQuantityChange}
                  >
                    {[...Array(10).keys()].map(x => (
                      <option key={x + 1} value={x + 1}>
                        {x + 1}
                      </option>
                    ))}
                  </select>
                </div>
                
                <button 
                  className="single-merch-buy-btn"
                  onClick={handleBuyNow}
                  disabled={merch.countInStock <= 0}
                >
                  Order Now
                </button>
                
                <div className="single-merch-description">
                  <p>{merch.description}</p>
                </div>
                
                {(merch.countInStock <= 0) && (
                  <div className="single-merch-outofstock">
                    <span>Out of Stock</span>
                  </div>
                )}
                
                {(merch.countInStock > 0 && merch.countInStock <= 5) && (
                  <div className="single-merch-lowstock">
                    <span>Low Stock - Only {merch.countInStock} left</span>
                  </div>
                )}
                
                <button 
                  className="single-merch-back-btn"
                  onClick={goBack}
                >
                  Back to Merchandise
                </button>
              </div>
            </div>
          )
        )}
      </div>
      </div>
    </>
  );
};

export default SingleMerch;